export default "__VITE_ASSET__BgwUnmwn__"